import helpers from './helpers';

export default {
    getPublicAccessToken() {
      return null;
    },

  getStorefrontToken() {
    // Retrieve token from global theme settings injected via Liquid
    return window.themeSettings?.storefront_access_token || "";
  },

  getXhrRequestConfig() {
    // XHR request header is required to catch certain errors e.g. adding over quantity available
    // https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
    // https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
    return {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  },

  getAdminGraphqlBaseUrl() {
    return `${helpers.getDomain()}/admin/api/2024-10/graphql.json`;
  },

  getStorefrontGraphqlBaseUrl() {
    return `${helpers.getDomain()}/api/2024-10/graphql.json`;
  },

  getBasketApiUrl() {
    return `https://${basketApiUrl[helpers.getShopDomain()]}/apps/strandbags/api/2021-04/`;
  }
};
